// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"_025a50318d--wrapper--PaXp8","item":"_025a50318d--item--FePeB","item-title":"_025a50318d--item-title--rIuqN","item-icon":"_025a50318d--item-icon--aD1BI"};